import { FC } from 'react';
import { Box } from '@mui/material';
import clsx from 'clsx';

import {
  getAllDayAbsenceEntryAtDate,
  getAllDayBlockTimeEntryAtDate,
} from 'src/utils';

import WeeklyAbsenceNote from './WeeklyAbsenceNote';
import WeeklyBlockTimeNote from './WeeklyBlockTimeNote';

import useStyles from './WeeklyBanner.styles';

interface Props {
  children: React.ReactNode;
  date: Date;
}

const WeeklyAgendaDayWrapper: FC<Props> = ({ children, date }) => {
  const classes = useStyles();
  const absence = getAllDayAbsenceEntryAtDate(date);
  const isAllDayBlockTime = !!getAllDayBlockTimeEntryAtDate(date);
  const isBlockedDay = !!absence || isAllDayBlockTime;

  return (
    <Box
      className={clsx(
        classes.noteWrapper,
        isBlockedDay && classes.noteWrapperBlockDay,
      )}
    >
      {absence ? (
        <WeeklyAbsenceNote kind={absence.kind} />
      ) : (
        isAllDayBlockTime && <WeeklyBlockTimeNote />
      )}

      {children}
    </Box>
  );
};

export default WeeklyAgendaDayWrapper;
